import { render } from "./mfa.vue?vue&type=template&id=6dbea9a3&scoped=true"
import script from "./mfa.vue?vue&type=script&lang=js"
export * from "./mfa.vue?vue&type=script&lang=js"

import "./mfa.vue?vue&type=style&index=0&id=6dbea9a3&scoped=true&lang=css"
import "./mfa.vue?vue&type=style&index=1&id=6dbea9a3&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbea9a3"]])

export default __exports__